import { FULL_POSITIONS, POSITIONS } from "../PoktoolsVariables";

const getPositionsForNbPlayers = (players) => {
  return POSITIONS.slice(0, players - 1).reverse();
};

const getVilainPositionsForNbPlayers = (players, hero = null) => {
  let index = 0;
  if (hero.length === 0) {
  } else {
    index = POSITIONS.indexOf(hero) + 1;
  }
  //console.log("positions for call push, index=" + index);
  //console.log("positions for call push, players - 1=" + (players - 1));
  return POSITIONS.slice(index, players - 1).reverse();
};
const getHeroPositionsForNbPlayers = (players, vilains) => {
  let index = players;
  if (vilains.length === 0) {
    //console.log("hero positions for call push, no vilains");
    return FULL_POSITIONS.slice(0, index - 1).reverse();
  } else {
    //console.log("hero positions for call push, vilains", vilains);
    let splits = vilains.split(",");
    for (let k = 0; k < splits.length; k++) {
      let vilain = splits[k];
      let vilainIndex = FULL_POSITIONS.indexOf(vilain);
      if (vilainIndex < index) {
        index = vilainIndex;
      }
    }
  }
  //console.log("hero positions for call push, index=" + index);
  //console.log("hero positions for call push, players - 1=" + (players - 1));
  return FULL_POSITIONS.slice(0, index).reverse();
};
const FastPokAspectRatio = {
  refSize: 620,
  refFontSize: 15,
  refMargin: 4,
  refCellSize: 37,
  refCardWidth: 20,
  refCardHeightRatio: 1.3828125,
  refBoardCardMargin: 3.5
};

export {
  FastPokAspectRatio,
  getVilainPositionsForNbPlayers,
  getHeroPositionsForNbPlayers,
  getPositionsForNbPlayers
};
